import { CollisionType, Color, Engine, Font, Label, ScreenElement, vec } from "excalibur";
import { collision_groups } from "../../scenes/level-one/collision_groups";
import { LevelOne } from "../../scenes/level-one/level-one";
import { Hud } from "./hud";

export class TopLeftBar extends ScreenElement {
    private moneyLabel: Label;

    constructor(private level: LevelOne) {
        super({
            height: 50,
            width: 150,
            z: 3433,
            color: new Color(64, 64, 64),
            collisionGroup: collision_groups.uiGroup
        });
    }

    onInitialize() {
        this.collider.useBoxCollider(this.width, this.height, vec(0, 0))
        this.body.collisionType = CollisionType.Passive;

        this.moneyLabel = new Label({
            pos: vec(8, 32),
            z: 33333,
            color: Color.White,
            font: new Font({
                family: "Sans-Serif",
                size: 32,
            })
        });

        this.addChild(this.moneyLabel);

        this.updateMoney();
    }

    onPostUpdate(engine: Engine, delta: number) {
        this.updateMoney();
    }

    private updateMoney() {
        this.moneyLabel.text = "$" + this.level.money;
    }
}